import api from '../../api';

export default function createOffer(brandId,data) {
  return api.post(`/brands/manage/${brandId}/offers`,data);
}